import React, { useState } from 'react';
import TextAreaComponents from '../../../../components/TextAreaComponents/TextAreaComponents.tsx';
import { Autocomplete, Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, FormGroup, Grid, IconButton, Radio, RadioGroup, Switch, Tab, TextField, Typography } from '@mui/material';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs, { Dayjs } from 'dayjs';

function UBOs(props) {
    const [FirstName, setFirstName] = useState(false)
    const [Lastname, setLastname] = useState(false)
    const [HomeAddress, setHomeAddress] = useState(false)
    const [ZipCode, setZipCode] = useState(false)
    const [City, setCity] = useState(false)
    const [Country, setCountry] = useState(false)
    const [PhoneNumber, setPhoneNumber] = useState(false)
    const [Email, setEmail] = useState(false)
    const [Passport, setPassport] = useState(false)
    const [Ownership, setOwnership] = useState(false)
    const [obj, setObj] = React.useState({
        // firstName: "",
        // lastName: "",
        // PersonelsType: 'UBO',
        // DOB: new Date(),
        // HomeAddress: '',
        // PostalCode: '',
        // City: '',
        // Country: '',
        // PhoneNumber: '',
        // EmailAddress: '',
        // Passport: '',
        // ownerShipValue: ''
        ID: 'Ubo',
        KycCompanyDetailsId: 'companyDetails',
        PersonelsType: 'UBO',
        FirstName: '',
        LastName: '',
        DOB: new Date(),
        HomeAddress: '',
        ZipCode: '',
        City: '',
        Country: '',
        PhoneNumber: '',
        EmailAddress: '',
        PassportOrIdNumber: '',
        Rank: 2,
        OwnerShipPercentage: 0,
        CreationId: 'creationId'
    })

    const sendDataToParent = () => {
        props.val(obj);
    }

    const firstnameFieldValue = (props) => {

        obj.FirstName = props;
        setFirstName(false)
        sendDataToParent();
    }
    const lastnameFieldValue = (props) => {

        obj.LastName = props;
        setLastname(false)
        if (obj.FirstName.trim() === '') {
            setFirstName(true)
        }
        sendDataToParent();
    }
    const [value, setValue] = React.useState<Dayjs | null>(dayjs('2022-04-17'));
    const DOBFieldValue = (props) => {

        var month = parseInt(props.$M + 1)
        var day = props.$y + '-' + month + '-' + props.$D
        var mydate = new Date(day);
        console.log(mydate);
        obj.DOB = mydate;
        sendDataToParent();
    }
    const homeAddressFieldValue = (props) => {

        obj.HomeAddress = props;
        setHomeAddress(false)
        if (obj.FirstName.trim() === '') {
            setFirstName(true)
        }
        if (obj.LastName.trim() === '') {
            setLastname(true)
        }
        sendDataToParent();
    }
    const postalCodeFieldValue = (props) => {

        obj.ZipCode = props;
        setZipCode(false)
        if (obj.FirstName.trim() === '') {
            setFirstName(true)
        }
        if (obj.LastName.trim() === '') {
            setLastname(true)
        }
        if (obj.HomeAddress.trim() === '') {
            setHomeAddress(true)
        }
        sendDataToParent();
    }
    const cityFieldValue = (props) => {

        obj.City = props;
        setCity(false)
        if (obj.FirstName.trim() === '') {
            setFirstName(true)
        }
        if (obj.LastName.trim() === '') {
            setLastname(true)
        }
        if (obj.HomeAddress.trim() === '') {
            setHomeAddress(true)
        }
        if (obj.ZipCode.trim() === '') {
            setZipCode(true)
        }
        sendDataToParent();
    }
    const CountryFieldValue = (props) => {

        obj.Country = props;
        setCountry(false)
        if (obj.FirstName.trim() === '') {
            setFirstName(true)
        }
        if (obj.LastName.trim() === '') {
            setLastname(true)
        }
        if (obj.HomeAddress.trim() === '') {
            setHomeAddress(true)
        }
        if (obj.ZipCode.trim() === '') {
            setZipCode(true)
        }
        if (obj.City.trim() === '') {
            setCity(true)
        }
        sendDataToParent();
    }
    const PhoneNumberFieldValue = (props) => {

        obj.PhoneNumber = props;
        setPhoneNumber(false)
        if (obj.FirstName.trim() === '') {
            setFirstName(true)
        }
        if (obj.LastName.trim() === '') {
            setLastname(true)
        }
        if (obj.HomeAddress.trim() === '') {
            setHomeAddress(true)
        }
        if (obj.ZipCode.trim() === '') {
            setZipCode(true)
        }
        if (obj.City.trim() === '') {
            setCity(true)
        }
        if (obj.Country.trim() === '') {
            setCountry(true)
        }
        sendDataToParent();
    }

    const [isValidEmail, setIsValidEmail] = useState(false);
    const validateEmail = (props) => {

        // const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;\
        const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        setIsValidEmail(!emailPattern.test(props));
    };
    const EmailAddressFieldValue = (props) => {

        obj.EmailAddress = props;
        setEmail(false)
        validateEmail(obj.EmailAddress)
        if (obj.FirstName.trim() === '') {
            setFirstName(true)
        }
        if (obj.LastName.trim() === '') {
            setLastname(true)
        }
        if (obj.HomeAddress.trim() === '') {
            setHomeAddress(true)
        }
        if (obj.ZipCode.trim() === '') {
            setZipCode(true)
        }
        if (obj.City.trim() === '') {
            setCity(true)
        }
        if (obj.Country.trim() === '') {
            setCountry(true)
        }
        if (obj.PhoneNumber.trim() === '') {
            setPhoneNumber(true)
        }
        sendDataToParent();
    }
    const PassportFieldValue = (props) => {

        obj.PassportOrIdNumber = props;
        setPassport(false)
        if (obj.FirstName.trim() === '') {
            setFirstName(true)
        }
        if (obj.LastName.trim() === '') {
            setLastname(true)
        }
        if (obj.HomeAddress.trim() === '') {
            setHomeAddress(true)
        }
        if (obj.ZipCode.trim() === '') {
            setZipCode(true)
        }
        if (obj.City.trim() === '') {
            setCity(true)
        }
        if (obj.Country.trim() === '') {
            setCountry(true)
        }
        if (obj.PhoneNumber.trim() === '') {
            setPhoneNumber(true)
        }
        if (obj.EmailAddress.trim() === '') {
            setEmail(true)
        }
        sendDataToParent();
    }
    const ownerShipValue = (props) => {

        obj.OwnerShipPercentage = props;
        if (obj.FirstName.trim() === '') {
            setFirstName(true)
        }
        if (obj.LastName.trim() === '') {
            setLastname(true)
        }
        if (obj.HomeAddress.trim() === '') {
            setHomeAddress(true)
        }
        if (obj.ZipCode.trim() === '') {
            setZipCode(true)
        }
        if (obj.City.trim() === '') {
            setCity(true)
        }
        if (obj.Country.trim() === '') {
            setCountry(true)
        }
        if (obj.PhoneNumber.trim() === '') {
            setPhoneNumber(true)
        }
        if (obj.EmailAddress.trim() === '') {
            setEmail(true)
        }
        if (obj.PassportOrIdNumber.trim() === '') {
            setPassport(true)
        }
        sendDataToParent();
    }
    return (
        <div>
            <div className='managementCards'>

                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <TextAreaComponents label={'First name'} value={firstnameFieldValue} error={FirstName} id={6}></TextAreaComponents>
                    </Grid>
                    <Grid item xs={6}>
                        <TextAreaComponents label={'Last name'} value={lastnameFieldValue} error={Lastname} id={6}></TextAreaComponents>
                    </Grid>
                    <Grid item xs={6}>
                        {/* <TextAreaComponents label={'Date of birth'} value={DOBFieldValue} id={6}></TextAreaComponents> */}
                        <LocalizationProvider dateAdapter={AdapterDayjs} sx={{ width: '100%', padding: "0" }}>
                            <DemoContainer components={['DatePicker']} sx={{ width: '100%', padding: "0" }}>
                                <DatePicker label="Date of birth" sx={{ width: '100%', padding: "0" }} onChange={(newValue) => DOBFieldValue(newValue)} className='custom-textField custom-DateField' maxDate={dayjs(new Date())} />
                            </DemoContainer>
                        </LocalizationProvider>
                    </Grid>
                    <Grid item xs={6}>
                        <TextAreaComponents label={'Home address'} value={homeAddressFieldValue} error={HomeAddress} id={6}></TextAreaComponents>
                    </Grid>

                    <Grid item xs={6}>
                        <TextAreaComponents label={'Postal code/Zip code '} value={postalCodeFieldValue} error={ZipCode} id={9}></TextAreaComponents>
                    </Grid>
                    <Grid item xs={6}>
                        <TextAreaComponents label={'City'} value={cityFieldValue} error={City} id={6}></TextAreaComponents>
                    </Grid>
                    <Grid item xs={6}>
                        <TextAreaComponents label={'Country'} value={CountryFieldValue} error={Country} id={6}></TextAreaComponents>
                    </Grid>
                    <Grid item xs={6}>
                        <TextAreaComponents label={'Phone number'} value={PhoneNumberFieldValue} id={12}></TextAreaComponents>
                    </Grid>
                    <Grid item xs={6}>
                        <TextAreaComponents label={'Email Address'} value={EmailAddressFieldValue} isValid={isValidEmail} error={Email} id={6}></TextAreaComponents>
                    </Grid>
                    <Grid item xs={6}>
                        <TextAreaComponents label={'Passport / ID number'} value={PassportFieldValue} error={Passport} id={9}></TextAreaComponents>
                    </Grid>
                    <Grid item xs={6}>
                        <TextAreaComponents label={'Ownership (%) '} value={ownerShipValue} id={9}></TextAreaComponents>
                    </Grid>
                </Grid>

            </div>
        </div>
    );
}

export default UBOs;